import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import CustomButton from "../components/CustomButton";
const useStyles = makeStyles({
  header: {
    minHeight: "70vh",
    height: "auto",
    width: "100%",
    background: "url(/images/teacher_header.jpg) no-repeat center center",
    backgroundSize: "cover",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      width: "100%",
      height: "100%",
      backgroundImage: "linear-gradient(68deg, #4938cb, #3721d2, #26189b)",
      opacity: 0.77,
    },
  },

  actionBar: {
    display: "flex",
    alignItems: "center",
    padding: "3vw 7vw",
    height: 70,
    position: "relative",
    color: "white",
    "& img": {
      height: 32,
      margin: "0px 8px",
    },
  },

  center: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    flexDirection: "column",
    position: "relative",
    color: "white",
    padding: "0px 10vw",
  },
  centerText: {
    textAlign: "center",
  },
  headerTitle: {
    fontSize: "55px",
    fontWeight: 300,
    fontStretch: "normal",
    fontStyle: "normal",
    marginTop: 76,

    lineHeight: "normal",
    letterSpacing: "normal",
  },
  headerDescription: {
    fontSize: "30px",
    // fontWeight: "light",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    fontWeight: 300,

    marginTop: 32,
    letterSpacing: "normal",
  },
  logo: {
    margin: "3vw 1vw",
  },
  applyButton: {
    margin: "10% auto",
    marginTop: 128,
    padding: "8px 56px",
    fontWeight: "normal",
    fontSize: 18,
  },
});

export default function Header(props) {
  const classes = useStyles();

  const { setShowForm } = props;

  return (
    <section>
      <header className={classes.header}>
        <section className={classes.actionBar}>
          {/* <img src="/images/logo_english.png" alt="Lingotalk!" /> */}
        </section>
        <section className={classes.center}>
          <Typography
            className={clsx(classes.centerText, classes.headerTitle)}
            variant="h5"
          >
            استاد زبان لینگوتاک شوید!‬
          </Typography>
          <Typography
            className={clsx(classes.centerText, classes.headerDescription)}
            variant="h5"
          >
            با کلاس خصوصی آنلاین، هر جا و هر زمان، درآمد کسب کنید‬
          </Typography>
          <CustomButton
            size="large"
            className={classes.applyButton}
            id="header-start-teaching"
            onClick={() => setShowForm(true)}
          >
            ثبت نام استاد
          </CustomButton>
        </section>
      </header>
    </section>
  );
}
